import { Component, ViewContainerRef, ElementRef } from '@angular/core';
import { UserService } from './services/user.service';
import { Router } from '@angular/router';
import { Overlay } from 'angular2-modal';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { Location } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  testServer: boolean = true;
  versionNumber: string;

  constructor(private overlay: Overlay, private vcRef: ViewContainerRef, public userService: UserService, private router: Router, private elRef: ElementRef, private _location: Location) {
    elRef.nativeElement.ownerDocument.body.style.paddingTop = '130px';
    overlay.defaultViewContainer = vcRef;
    userService.getServerInfo('profile').subscribe(data => {
      if (data.toLowerCase() === "prod")
        this.testServer = false;
    });
    userService.getServerInfo('serverversion').subscribe(
      data => this.versionNumber = data
    );
  }

  logout() {
    this.router.navigate(['login']);
    this.userService.logout();
  }

  goBack() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts